import Image8 from '../assets/images/icons/8.svg'
import Image10 from '../assets/images/icons/10.svg'
import Image11 from '../assets/images/icons/11.svg'
import Image12 from '../assets/images/icons/12.svg'
import Image15 from '../assets/images/icons/15.svg'
import Image22 from '../assets/images/icons/22.svg'
import Image27 from '../assets/images/icons/27.svg'
import Image28 from '../assets/images/icons/28.svg'
import Image37 from '../assets/images/icons/37.svg'
import Image32 from '../assets/images/icons/32.svg'
import Image33 from '../assets/images/icons/33.svg'
import Image34 from '../assets/images/icons/34.svg'

export const types: any = [
    {id: 1, label: "Selling"},
    {id: 2, label: "Rent"},
]
export const typesForSelect: any = [
    {value: 1, label: "Selling"},
    {value: 2, label: "Rent"},
]
export const categories: any = [
    {id: 7, label: "apartment"},
    {id: 6, label: "commercial_property"},
    {id: 8, label: "land"},
    {id: 9, label: "house"},
]
export const categoriesTrans: any = [
    {id: 7, label: "Apartments"},
    {id: 6, label: "Commercial properties"},
    {id: 8, label: "Land"},
    {id: 9, label: "Houses"},
]
export const categoryList: any = [
    "apartment",
    "commercial_property",
    "land",
    "house",
];
export const categoryAlias: any = {
  7: 'apartment',
  6: 'commercial_property',
  8: 'land',
  9: 'house'
}
export const typeList: any = [
    "Sale",
    "Rent",
];
export const typeAlias: any = {
    1: "Sale",
    2: "Rent",
};
export const categoryAliasId: any = {
    "apartment": 7,
    "commercial_property": 6,
    "land": 8,
    "house": 9,
};
export const categoryTranslations: any = {
    "commercial_property": 'Commercial properties',
    "apartment": 'Apartments',
    "land": 'Land',
    "house": 'Houses',
};
export const categoryIdTranslations: any = {
    6: 'Commercial properties',
    7: 'Apartments',
    8: 'Land',
    9: 'Houses',
};
export const categoryNameUrlAlias: any = {
    "apartment": "apartments",
    "commercial-property": "commercial-properties",
    "land": "land",
    "house": "houses",
};
export const categoryIdUrlAlias: any = {
    7: "apartments",
    6: "commercial-properties",
    8: "land",
    9: "houses",
};
export const typeAliasId: any = {
    "Sale": 1,
    "Rent": 2,
};
export const parameterIcons: any = {
    8: Image8,
    9: Image10,
    10: Image10,
    11: Image11,
    12: Image12,
    15: Image15,
    22: Image22,
    27: Image27,
    28: Image28,
    37: Image37,
    32: Image32,
    33: Image33,
    34: Image34,
}

export const getCategoryAndType: any = (lastSegment: string, secondSegment: any = null) => {
    switch (lastSegment) {
        case "houses-for-sale":
            return {category: 'house', type: 'Sale', rooms: null, building_type: null}
        case "houses-for-rent":
            return {category: 'house', type: 'Rent', rooms: null, building_type: null}
        case "land-for-sale":
            return {category: 'land', type: 'Sale', rooms: null, building_type: null}
        case "land-for-rent":
            return {category: 'land', type: 'Rent', rooms: null, building_type: null}
        case "commercial-properties-for-sale":
            return {category: 'commercial_property', type: 'Sale', rooms: null, building_type: null}
        case "commercial-properties-for-rent":
            return {category: 'commercial_property', type: 'Rent', rooms: null, building_type: null}
        case "apartments-for-sale":
            if (secondSegment === '1-room-apartments') {
                return {category: 'apartment', type: 'Sale', rooms: 1, building_type: null}
            } else if (secondSegment === '2-room-apartments') {
                return {category: 'apartment', type: 'Sale', rooms: 2, building_type: null}
            } else if (secondSegment === '3-room-apartments') {
                return {category: 'apartment', type: 'Sale', rooms: 3, building_type: null}
            } else if (secondSegment === '4-room-apartments') {
                return {category: 'apartment', type: 'Sale', rooms: 4, building_type: null}
            } else {
                return {category: 'apartment', type: 'Sale', rooms: null, building_type: null}
            }
        case "apartments-for-rent":
            if (secondSegment === '1-room-apartments') {
                return {category: 'apartment', type: 'Rent', rooms: 1, building_type: null}
            } else if (secondSegment === '2-room-apartments') {
                return {category: 'apartment', type: 'Rent', rooms: 2, building_type: null}
            } else if (secondSegment === '3-room-apartments') {
                return {category: 'apartment', type: 'Rent', rooms: 3, building_type: null}
            } else if (secondSegment === '4-room-apartments') {
                return {category: 'apartment', type: 'Rent', rooms: 4, building_type: null}
            } else {
                return {category: 'apartment', type: 'Rent', rooms: null, building_type: null}
            }
        case "new-construction-apartments":
            if (secondSegment === '1-room-apartments') {
                return {category: 'apartment', type: 'Sale', rooms: 1, building_type: 50}
            } else if (secondSegment === '2-room-apartments') {
                return {category: 'apartment', type: 'Sale', rooms: 2, building_type: 50}
            } else if (secondSegment === '3-room-apartments') {
                return {category: 'apartment', type: 'Sale', rooms: 3, building_type: 50}
            } else if (secondSegment === '4-room-apartments') {
                return {category: 'apartment', type: 'Sale', rooms: 4, building_type: 50}
            } else {
                return {category: 'apartment', type: 'Sale', rooms: null, building_type: 50}
            }
    }
}